import { render, staticRenderFns } from "./IconArrowDown.vue?vue&type=template&id=fedbd61a&"
import script from "./IconArrowDown.vue?vue&type=script&lang=js&"
export * from "./IconArrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports